import { getCookie } from '../../utils/cookieUtils'
import FormContainer, { CheckboxType } from '../shared/formContainer/FormContainer'
import PropTypes from 'prop-types'

export default function TermsAndConditionsSection( props ) {
    const cookie = getCookie( '.REGION' )
    let rootPath = '/content/general'
    if( cookie ) {
        rootPath = JSON.parse( cookie ).Root
    }

    return (
        <FormContainer 
            formTitle = "Terms and Conditions"
            formTitleClassName = "c-form-intro c-form-intro--long"
            containerClassName = "c-form-container c-form-container--box c-form-container--box-row mb-5"
            formInputComponents = { [ 
                { 
                    ...props.checkboxConfig,
                    checkboxLabelText: (
                        <>
                            <label className="u-type-size-2 u-text--dark-grey c-form-label-custom-terms-and-conditions">
                                By checking this box, you acknowledge that you have read and agree to the Eversource&nbsp; 
                                <a href="/content/residential/about/terms-and-conditions" target="_blank" className="c-link">Terms and Conditions.</a>
                                &nbsp;
                            </label>
                            <label className="u-type-size-2 u-text--dark-grey c-form-label-custom-terms-and-conditions c-form-margin-bottom-0">
                                Review our&nbsp;
                                <a href="/content/residential/about/privacy-policy" target="_blank" className="c-link">Privacy Policy.</a>
                            </label>
                        </>
                    ),
                    id: 'termsAndConditionsCheckbox',
                    tabIndex: 0,
                    ariaLabel: 'By checking this box, you acknowledge that you have read and agree to the Eversource Terms and Conditions. Review our Privacy Policy. Terms and Conditions',
                    visible: true,
                    inputType: CheckboxType,
                    inputWrapperClassName: 'c-form-input-wrapper-70-width',
                    'data-testid': 'termsAndConditionsCheckbox'
                }
            ] }
            notificationVisible = { false }
            showInputComponentsInColum = { false }
        >
        </FormContainer>
    )
}

TermsAndConditionsSection.propTypes = {
    checkboxConfig: PropTypes.instanceOf( Object ),
}